var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "sip-view-page" }, [
    _c("div", { staticClass: "nk-block-head nk-block-head-sm sip-view-head" }, [
      _c("div", { staticClass: "nk-block-between" }, [
        _c("div", { staticClass: "nk-block-head-content" }, [
          _c("h3", { staticClass: "nk-block-title page-title" }, [
            _vm._v(_vm._s(_vm.trans("general.about"))),
          ]),
          _vm._v(" "),
          _vm._m(0),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row sip-view-grid" }, [
      _c("div", { staticClass: "col-12 col-lg-8" }, [
        _c("div", { staticClass: "card sip-view-card" }, [
          _c("div", {
            staticClass: "card-body sip-view-rich",
            domProps: { innerHTML: _vm._s(_vm.content) },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-lg-4" }, [
        _c("div", { staticClass: "card sip-view-card" }, [
          _c(
            "div",
            { staticClass: "card-body" },
            [_c("product", { attrs: { product: _vm.product } })],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "nk-block-des text-soft" }, [
      _c("p", [_vm._v("Product context and release details.")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }